import { StyleSheet } from 'react-native';
import { scale } from '@components/frame';
import { isPhone } from '@helpers';
import { LINE_HORIZONTAL_PADDING } from '@v2/pages/common/constants/base.constants';

export const styles = StyleSheet.create({
  leftColumnStyles: {
    alignItems: 'center',
    ...(!isPhone ? { flex: 1 } : {}),
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  rightColumnStyles: {
    ...(!isPhone ? { flex: 2 } : {}),
  },
  rowPaddings: { paddingTop: scale(9.5), paddingBottom: scale(10), paddingLeft: scale(LINE_HORIZONTAL_PADDING) },
  rowStylesWithoutPaddings: {
    flexDirection: 'row',
    alignItems: 'center',
    ...(isPhone ? { justifyContent: 'space-between', paddingRight: scale(15) } : {}),
  },
});
